module.exports = __webpack_public_path__ + "static/img/bg-06.8cd8fbb.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/form/design/assets/bg-06.png
// module id = L9mL
// module chunks = 64